import { number } from 'yup';

const MIN_PAYOFF_AMOUNT = 1;
const MAX_PAYOFF_AMOUNT = 999999;

export const payoffAmountValidation = number()
  .required('Payoff amount is required')
  .min(MIN_PAYOFF_AMOUNT, 'Must be greater than or equal to 1')
  .max(MAX_PAYOFF_AMOUNT, 'Must be less than 1 million');

const RETAIL_BOOK_VALUE_FLOOR_RATIO = 0.4;
const ABSOLUTE_PAYOFF_FLOOR = 5000;

const lowPayoffFloor = (retailBookValue?: number | null) =>
  retailBookValue && retailBookValue > 0
    ? retailBookValue * RETAIL_BOOK_VALUE_FLOOR_RATIO
    : ABSOLUTE_PAYOFF_FLOOR;

export const isPayoffBelowFloor = (
  value: number | null | undefined,
  retailBookValue?: number | null,
) => value != null && value < lowPayoffFloor(retailBookValue);
